import {HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import {Serialize} from "dcerialize";
import type {Observable} from "rxjs";
import {map} from "rxjs";
import {ContactForm} from "../../models/ContactForm/ContactForm";
import {BaseApi} from "./base-api";

@Service()
export class ContactFormApi extends BaseApi {
  private readonly http = inject(HttpClient);

  public constructor() {
    super("contact-form");
  }

  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  public submit(form: Readonly<ContactForm>): Observable<void> {
    // eslint-disable-next-line new-cap
    return this.http.post(this.getEndpointUrl("send"), Serialize(form, () => ContactForm), {
      observe: "response",
      responseType: "blob",
      // eslint-disable-next-line @typescript-eslint/no-empty-function
    }).pipe(map(() => {
    }));
  }
}
